export function toSentence<T = any>(arr: T[], separator = 'and'): string {
  if (arr.length === 0) return '';
  if (arr.length === 1) return String(arr[0]);

  return `${arr.slice(0, arr.length - 1).join(', ')} ${separator} ${arr.slice(-1)}`;
}

export default toSentence;
